<template>
  <v-layout row wrap align-center>
    <v-flex>
      <v-flex mb-5 text-xs-left>
        <div v-if="page === 'SignUp'">
          Nice. Now confirm your cell(mobile) phone number starting with area code.
        </div>
        <div v-if="page === 'Register'">
          <p>Start the certificate program by updating your profile. This is the KEY to workplace compliance.
          ID info is used for online proctoring and issuing the eBadge and certificate.</p>
          <p>Confirm your cell(mobile) phone number starting with area code.</p>
        </div>
      </v-flex>
      <v-flex xs12 >
        <vue-tel-input
          v-model="phone"
          @input="checkPhone"
          @blur="phoneBlur"
          @focus="phoneFocussed"
          @enter="confirmMyPhone"
          :preferredCountries="['US','CA','GB']"
          :dropdownOptions="{
            showDialCodeInSelection: true,
            showFlags: true
          }"
        >
          <template v-slot:arrow-icon>
            <span></span>
          </template>
        </vue-tel-input>
        <div class="grey--text text--darken-2 px-3">
          A cell(mobile) number is required to confirm your identity and for online proctoring</div>
      </v-flex>

      <v-flex d-flex xs12 mt-3>
        <v-btn
          :disabled="!validPhone || (phoneVerified && !inputChange)"
          @click="confirmMyPhone"
          :loading="loading"
          class="mr-0 ml-0"
          color="success">Confirm Phone NUmber</v-btn>
      </v-flex>

      <v-flex d-flex xs12  v-if="!phoneVerified">
        <v-btn class="mr-0 ml-0" @click="goToSignupStep(page, 'confirm-my-email')" color="primary">&#8592; Back</v-btn>
      </v-flex>

      <v-flex xs12 d-flex v-if="phoneVerified">
        <v-btn class="ml-0" @click="goToSignupStep(page, 'confirm-my-email')" color="primary">&#8592; Back</v-btn>

        <v-btn class="mr-0" @click="goToSignupStep(page, 'confirm-name')" color="primary">Next &#8594;</v-btn>

      </v-flex>

    </v-flex>
  </v-layout>
</template>

<script>
import crypto from '@/mixins/crypto'
import common from '@/mixins/common'
import { mapGetters, mapMutations } from 'vuex'

const VueTelInput = () =>
  Promise.all([
    import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
    import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css')
  ]).then(([{ VueTelInput }]) => VueTelInput)

export default {
  name: 'ConfirmMyPhone',
  data () {
    return {
      loading: false,
      inputChange: false,
      formattedPhone: '',
      phone: '',
      phoneObj: {},
      validPhone: false,
      errorMsg: '',
      isLoader: false,
      dictionary: {
        custom: {
          'slot1.phone': {
            required: () => 'Phone is required',
            length: 'A cell (mobile) number is required to confirm your identity and for online proctoring'
          }
        }
      }
    }
  },
  props: {
    page: {
      default: 'SignUp',
      type: String
    }
  },
  components: {
    VueTelInput
  },
  computed: {
    ...mapGetters('registration', ['getUserDetails']),
    phoneVerified () {
      return this.getUserDetails.phone_verified
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
    this.phone = this.decryptData(this.getUserDetails.national_number)
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    checkPhone (phoneNUmber, payload) {
      this.phoneObj = {...payload}
      this.formattedPhone = payload.countryCallingCode + '' + payload.nationalNumber
      this.validPhone = payload.valid
    },
    phoneBlur () {
      // this.inputChange = true
      // this.validPhone = false
    },
    phoneFocussed () {
      if (this.phoneVerified) {
        this.inputChange = true
        this.validPhone = false
      }
    },
    confirmMyPhone () {
      if (!this.validPhone) {
        return
      }

      this.loading = true
      this.$store.dispatch('registration/sendOtpOnPhone', this.formattedPhone)
        .then((res) => {
          if (res) {
            this.setUser({
              ...this.getUserDetails,
              phone: this.encryptData(this.formattedPhone),
              phone_object: this.phoneObj,
              national_number: this.encryptData(this.phone),
              phone_otp_id: res.data.otpId
            })
            this.$router.push({name: this.page,
              params: {step: 'phone-verification'}})
          } else {
            this.errors.add({
              scope: 'slot1',
              field: 'phone',
              msg: 'Unexpected error'
            })
          }
          this.loading = false
        })
    }
  },
  mixins: [crypto, common]
}
</script>

<style>
  .vue-phone-number-input .select-country-container {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 90px!important;
    flex: 0 0 90px!important;
    width: 90px!important;
    min-width: 90px!important;
    /* max-width: 120px; */
  }
</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/ConfirmMyPhone.vue